import React, { useState, useEffect, useCallback } from 'react'
import { Col, CustomInput } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import { useDispatch, useSelector } from 'react-redux'
import { SelectUserState, Button as ButtonNormal } from '../Form'
import _get from 'lodash.get'

import SidePopup from '../SidePopupNew'
import { activeUserAct, assignationsAct } from '../../redux/actions'
import './styles.scss'

import ProviderNameText from 'components/common/ProviderNameText'

import CodClient from './CodClient'
import LinkCRM from './LinkCRM'
import dkvConfiguration from 'constants/dkv.constants'
import TimeAndDate from 'utils/TimeAndDate'
import { toast } from 'react-toastify'
import { company, deleteManagerAPI } from 'api'
import OperatorAssignCard from 'components/AssignOperator/OperatorAssignCard'
import { getStaticImage } from 'utils/statics'
import general from 'api/users/general'
import conversation from 'api/conversation'
import { EditableLabel } from './EditableLabel'
import { lang } from 'utils/helpers'
import { removeUserTabs } from 'redux/actions/tabs'
import { conversationAct } from 'redux_new/actions'
import { removeConversation } from 'redux/actions/conversations/conversations'
import { useHistory } from 'react-router-dom'
import { MenuDotsOptions } from 'components/common'
import Nixi1Spinner from 'components/Nixi1Spinner'

const CHANNELS_REFRESH = [
  'instagram', 'facebook', 'instagram_post', 'facebook_post',
  'outlook', 'office360', 'exchange', 'telegram'
]

/**
 * Edit user
 * @param {object} props
 * @param {object} props.currentUser user object
 * @param {boolean} props.onHide Display popup
 */
const EditUser = (props) => {
  const { loggedUser, currentUser, onHide } = props
  const {
    assignedTo, brand, delegation, name, notMarketingSubscription,
    state: userState, metadata, companyName, isRemoveByUser=false
  } = currentUser

  const assignations = useSelector(store => store.assignations)
  const dispatch = useDispatch()
  const history = useHistory()

  const [state, setState] = useState({ brand, delegation, name, notMarketingSubscription, state: userState, companyName })
  const [assignedDashuser, setAssignedDashuser] = useState('')
  const [centersName, setCentersName] = useState({ brand: '', delegation: '' })
  const [isSubmitting, setIsSubmitting] = useState(false)
  const companies = useSelector(state => state.companies)
  const [loading, setLoading] = useState(true)
  const [gettingAvatar, setGettingAvatar] = useState(false)
  const [avatarUrl, setAvatarUrl] = useState(currentUser.avatarUrl)
  const [changingState, setChangingState] = useState(false)
  const [updatedState, setUpdatedState] = useState('')
  const subjectId = useSelector(state => state.conversations[currentUser.id].composer.currentSubject?._id)
  const [isOpenRemoveModal, setIsOpenRemoveModal] = useState(false)

  useEffect(() => {
    getBrandsAndDelegations(brand, delegation)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setState({ brand, delegation, name, notMarketingSubscription, state: userState, companyName })
  }, [brand, delegation, name, notMarketingSubscription, userState, companyName])

  const updateState = useCallback((data) => {
    setState({
      brand: data.brand, delegation: data.delegation,
      name: data.name, state: data.state,
      notMarketingSubscription: data.notMarketingSubscription,
      companyName: data.companyName
    })
  }, [])

  useEffect(() => {
    if (assignedTo.length && Object.keys(assignations).length) {
      const operator = Object.values(assignations).filter((item) => assignedTo.includes(item._id))
      let operators = []
      operator.forEach(it => {
        operators.push(it)
      })
      if (operators.length > 0) {
        setAssignedDashuser(operators)
      }
    } else if (assignedTo.length) {
      dispatch(assignationsAct.getAssignations({
        brands: [brand],
        delegations: [delegation],
        dashuser: { company: currentUser.company },
      }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignations, assignedTo])

  const getBrandsAndDelegations = async (brand, delegation) => {
    const [_brands, _delegations] = await Promise.all([
      company.brands.getBrands({ idCompany: companies._id, _id: brand }),
      company.delegations.getDelegations({ idCompany: companies._id, _id: delegation })
    ])

    setCentersName({
      brand: _brands.data.results ? _brands.data.results.name : '',
      delegation: _delegations.data.results ? _delegations.data.results.name : ''
    })
    setLoading(false)
  }

  const validateInput = () => {
    let errors = {},
      validate = true

    if (!state.name) errors.name = 'required-field'
    if (!state.brand) errors.brand = 'required-field'
    if (!state.delegation) errors.delegation = 'required-field'
    if (!state.state) errors.state = 'required-field'

    if (Object.keys(errors).length) validate = false

    //setErrors(errors)
    return validate
  }

  const handleSubmit = async () => {
    if (validateInput()) {
      setIsSubmitting(true)

      await dispatch(activeUserAct.updateUser({ ...currentUser, ...state }))

      setIsSubmitting(false)
      toast(I18n.t('dashboard_updated-user'), { position: 'top-center' })
      props.onHide()
    }
  }

  const onChange = ({ target: { name, value, type, checked } }) => {
    if (name === 'state') {
      setChangingState(true)
      conversation.conversations.changeState({ userId: currentUser._id, state: value, subjectId: subjectId }).then(r => {
        setChangingState(false)
        setUpdatedState(I18n.t('dashboard_updated'))
        setTimeout(() => {
          setUpdatedState('')
        }, 3000)
      }).catch(e => {
        setChangingState(false)
        setUpdatedState('')
      })
    }
    setState({ ...state, [name]: type === 'checkbox' ? checked : value })
  }

  const { codcliente = '', guidcliente = '', tipocliente = '' } = metadata || {}
  const channelId = _get(currentUser, 'channels.0.origin')
  const hasRefreshAvatar = CHANNELS_REFRESH.includes(currentUser?.channels?.[0]?.channel)

  const onRefreshAvatar = async () => {
    try {
      setGettingAvatar(true)
      const result = await general.getAvatar({ userId: currentUser.id })
      if (result.data.avatarUrl)
        setAvatarUrl(result.data.avatarUrl)
      setGettingAvatar(false)
    } catch (error) {
      setGettingAvatar(false)
    }
  }

  const disabledUserState = () => {
    if (isRemoveByUser) return true
    if (currentUser.provider_name === 'chatmail') return true
    return false
  }

  const handleDeleteConversation = async () =>{
    try{
      const response = await deleteManagerAPI.deleteConversation({ userId: currentUser.id })

      if(response.data?.success){
        dispatch(removeUserTabs(currentUser.id))
        dispatch(conversationAct.removeOne(currentUser.id))
        dispatch(removeConversation(currentUser.id))
        onHide()
        history.push(`/dashboard/conversations/users`)
      }

    }catch(error){
      toast(lang('error_conversation_delete'), { position: 'top-right' })
    }
  }

  return (
    <SidePopup onHide={onHide} header={I18n.t('dashboard_edit-user')}>
      {loading ? <div className='containerSpinner'> <Nixi1Spinner height='85vh' /> </div>
        : <div className='edit-user-form fadeIn animated'>
          {dkvConfiguration.isDKV && (
            <>
              <CodClient
                value={codcliente || ''}
                jsonKey='metadata.codcliente'
                ticketId={currentUser.id}
                onUpdateUser={updateState}
              />
              <div className='seccion-one'>
                <label>Guid</label>
                <span>
                  {guidcliente}
                </span>
              </div>
            </>
          )}

          <div className={`seccion-avatar`}>
            <div className='seccion-image'>
              <div className='avatar-icon-wrapper'>
                <img
                  className={'avatar-icon'}
                  src={avatarUrl ? avatarUrl : getStaticImage('/icons/orange-brand/icon-avatar.svg')}
                  alt={'avatar'}
                  onError={event => {
                    event.target.src = getStaticImage('/icons/orange-brand/icon-avatar.svg')
                    event.onerror = null
                  }}
                />
                {
                  hasRefreshAvatar && !isRemoveByUser ? (
                    <i
                      className={`avatar-refresh fa fa-refresh ${gettingAvatar ? 'rotate-avatar' : ''}`}
                      onClick={()=>{
                        if (gettingAvatar) return null
                        else onRefreshAvatar()
                      }}
                    />
                  ) : null
                }
              </div>
            </div>

            <div className='seccion-fields'>
              <div className='seccion-one'>
                <label>{I18n.t('dashboard_conversation-id')}</label>
                <span>{currentUser.id}</span>
              </div>

              <div className='seccion-one'>
                <label>{I18n.t('dashboard_name')}</label>
                <input
                  className='input'
                  type='text'
                  value={state.name}
                  name='name'
                  onChange={onChange}
                  disabled={isRemoveByUser}
                />
              </div>

              <div className='seccion-one'>
                {isRemoveByUser ? <label>{I18n.t('conversation_company_name')}</label> :
                  <EditableLabel
                    tag='conversation_company_name'
                    loggedUser={loggedUser}
                  />
                }
                <input
                  className='input'
                  type='text'
                  value={state.companyName}
                  name='companyName'
                  onChange={onChange}
                  disabled={isRemoveByUser}
                />
              </div>

              <div className='seccion-one'>
                <label>{I18n.t('dashboard_state')}</label>
                <SelectUserState
                  allStates={true}
                  allowEmpty={false}
                  value={state.state}
                  onChange={onChange}
                  // isDisabled={currentUser.provider_name !== 'chatmail' ? false : subjectId ? false : true}
                  isDisabled={disabledUserState()}
                />
                { changingState ? <Nixi1Spinner width='25px' height='25px'/> : updatedState && <span className='updated-state'>{updatedState}</span> }
              </div>

              <div className='seccion-two'>
                <label>{I18n.t('dashboard_deactivate-campaigns')}</label>
                <CustomInput
                  type='switch'
                  id='user.notMarketingSubscription'
                  name='notMarketingSubscription'
                  checked={state.notMarketingSubscription}
                  value={state.notMarketingSubscription}
                  onChange={onChange}
                  disabled={isRemoveByUser}
                />
              </div>
            </div>
          </div>

          <div className='users-to-assign-wrapper'>
            <div className='section-subtitle-inner'>{`${I18n.t('dashboard_assigned-operators')} (${assignedDashuser.length})`}</div>
            <div className='users-to-assign' style={{ maxHeight: 200 }}>
              {assignedDashuser.length > 0 && (
                assignedDashuser.map((operator) => {
                  return (
                    <OperatorAssignCard
                      key={operator._id}
                      id={operator._id}
                      operator={operator}
                    />
                  )})
              )}
            </div>
          </div>

          {dkvConfiguration.isDKV && (
            <div className='seccion-one'>
              <label>Tipo</label>
              <span>
                {tipocliente}
              </span>
            </div>
          )}

          <div className='seccion-one'>
            <label>{I18n.t('dashboard_channel')}</label>
            <span>
              <ProviderNameText channels={currentUser.channels} />
            </span>
          </div>
          <div className='seccion-one'>
            <label>{I18n.t('dashboard_recipient')}</label>
            <span>
              {channelId}
            </span>
          </div>

          <div className='seccion-one'>
            <label>{I18n.t('dashboard_createdAt')}</label>
            <span>
              {TimeAndDate.formatWithoutSeconds(currentUser.createdAt)}
            </span>
          </div>
          <div className='seccion-one'>
            <label>{I18n.t('dashboard_updatedAt')}</label>
            <span>
              {TimeAndDate.formatWithoutSeconds(currentUser.updatedAt)}
            </span>
          </div>
          {currentUser.locale ? (
            <div className='seccion-one'>
              <label>{I18n.t('dashboard_language')}</label>
              <span>
                {I18n.t(`locale_${currentUser.locale.slice(0, 2).toLowerCase()}`)}
              </span>
            </div>
          ) : null}

          <div className='seccion-one'>
            <label>{I18n.t('dashboard_brand')}</label>
            <span>
              {state.brand && centersName.brand ? centersName.brand : ''}
            </span>
          </div>
          <div className='seccion-one'>
            <label>{I18n.t('dashboard_delegation')}</label>
            <span>
              {state.delegation && centersName.delegation ? centersName.delegation : ''}
            </span>
          </div>

          {!isRemoveByUser && (
            <>
              <div className='containerBtnEditUser'>
                <ButtonNormal
                  secondary
                  value={I18n.t('dashboard_save')}
                  isSubmitting={isSubmitting}
                  onClick={handleSubmit}
                />
                {dkvConfiguration.isDKV ? <Col sm='2'><LinkCRM metadata={metadata} /></Col> : null}
                <ButtonNormal
                  value={I18n.t('dashboard_cancel')}
                  onClick={props.onHide}
                />
                <MenuDotsOptions
                  className='containerBtnEditUser__buttonRemove-wrapper'
                  typeOptions={'button'}
                  options={'delete'}
                  onClickButton={() => setIsOpenRemoveModal(true)}
                  isOpenModalDelete={isOpenRemoveModal}
                  toggleDelete={() => {
                    setIsOpenRemoveModal(!isOpenRemoveModal)
                  }}
                  type={'conversation'}
                  eventDelete={() => {
                    handleDeleteConversation()
                    setIsOpenRemoveModal(!isOpenRemoveModal)
                  }}
                />
              </div>
            </>
          )}
        </div>
      }
    </SidePopup>
  )
}

export default EditUser